.fp-printer(v-if='isPrinting')
  component(:is='componentToPrint.component' data-test='printer-component' :options='componentToPrint.options' @ready='printComponent')
